import { makeStyles } from '@mui/styles';

const commonFormWrap = {
  display: 'flex',
  margin: '0.8rem'
};

export const useStyles = makeStyles((theme) => ({
  emergencyInfoContainer: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  emergencyInfoForm: {
    minHeight: 710,
  },
  emergencyContentWrap: {
    minHeight: 710,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  fullWidth: {
    width: '100%'
  },
  subTextColor: {
    color: theme.palette.primary.main
  },
  formPageNumber: {
    fontSize: 16,
    textAlign: 'right',
    padding: '0.5rem 0.75rem 0 0',
    [theme.breakpoints.down(370)]: {
      fontSize: 12,
    }
  },
  nameEmailContainerStyle: commonFormWrap,
  nameContainer: {
    marginRight: '1rem',
    minWidth: '45%'
  },
  emergencyAddrContainerStyle: {
    marginRight: '1rem',
    minWidth: '55%'
  },
  contentTitleWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0.625rem 0 1rem 0',
  },
  contentTitleLine: {
    width: '100%',
    height: 0,
    border: '1px solid #567282',
    display: 'inline-block',
    background: '#567282'
  },
  titleLine1: {
    margin: '4px 10px 0 26px',
  },
  titleLine2: {
    margin: '4px 26px 0 10px',
  },
  contentTitle: {
    color: theme.palette.primary.dark,
    fontSize: 20,
    fontWeight: '500',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(370)]: {
      fontSize: 16,
    }
  },
  veteranContentTitle: {
    [theme.breakpoints.down(425)]: {
      letterSpacing: '-1.5px',
    }
  },
  buttonsNavContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 1rem 1rem 1rem',
    '& .MuiCircularProgress-root': {
      color: '#fff'
    }
  },
  branchServedContainer: {
    marginRight: '1rem',
    minWidth: '45%'
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 14,
    margin: '2px 0 0 4px',
  },
  submitBtn: {
    padding: '6px 28px',
  },
  btnDisabled: {
    background: theme.palette.common.grey,
    color: '#9e9e9e',
    '&:hover': {
      background: theme.palette.common.grey,
      color: '#9e9e9e',
    }
  }
}));
